module.exports = __webpack_public_path__ + "tn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tn.svg
// module id = 848
// module chunks = 0